/**
 * @module Core
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Injectable } from '@angular/core';
import { InjectablePDLService } from '@experience/reb-pdl/services/injectablepdl.service';
import { PdlService } from '@experience/reb-pdl/services/pdl.service';

import { AppConfig } from '@root/app.config';
import { Subject } from 'rxjs';

@Injectable()
export class PdlWrapperService extends InjectablePDLService {
  public pdlEnabled: boolean;
  public isPdlDepsLoaded: boolean;
  public pdlSetCaptureEventObservable: Subject<void>;
  public pdlDefaultData: {};
  public formStartNameArr: string[];

  constructor(
    public pdlService: PdlService,
    private appConfig: AppConfig
  ) {
    super(pdlService);
    this.formStartNameArr = [];
    this.pdlDefaultData = {
      '*': {
        pageLoad: {
          custom: {
            eventObjectTemplate: {
              eventInfo: {
                eventAction: 'load',
                eventType: 'page',
              },
            },
            eventAnalytics: [],
            map: [],
            handlers: ['myGenerateEventInfoTimestamp'],
          },
        },
      },
    };
    this.pdlSetCaptureEventObservable = new Subject();
    this.pdlEnabled = this.appConfig.getConfig('pdlEnabled') || false;
  }

  public trackData(pageIdentifier: string, ctaId: string, data: Object): void {
    if (this.pdlEnabled) {
      super.trackData(pageIdentifier, ctaId, data);
    }
  }

  public setDataTrackConfig(data: Object): void {
    if (this.pdlEnabled) {
      super.setDataTrackConfig(data);
    }
  }

  public setCustomHandlers(data: Object): void {
    if (this.pdlEnabled) {
      super.setCustomHandlers(data);
    }
  }

  public setEventCaptureConfig(data: Object, global: boolean = false): void {
    if (this.pdlEnabled) {
      super.setEventCaptureConfig(data, global);
    }
  }
}
